import { Box } from '@cad-arc';
import { GenericObject } from '../common/types';
import { useUnitEmergency } from '../unit-emergency/use-unit-emergency';

export function FrPageBody(props: {
    children: React.ReactNode;
    customStyles?: GenericObject<string | number>;
}) {
    const { filteredUnAckedUnitEmergencies } = useUnitEmergency();

    return (
        <Box
            h={`calc(100%${
                filteredUnAckedUnitEmergencies.length > 0
                    ? ` - ${23 + (4 * filteredUnAckedUnitEmergencies.length - 1)}%`
                    : ''
            })`}
            w="100%"
            style={{ marginTop: 0, ...(props.customStyles ?? {}) }}
            overflowY="auto"
            data-testid="fr-page-body"
            background="surface.canvas"
        >
            {props.children}
        </Box>
    );
}
